import { createActions } from 'redux-actions';
import { apiActionPayloadCreator, apiActions as commonApiActions } from '../common';

export const API_ENDPOINT = 'configurations/public';

const actions = createActions({
  CONFIG: {
    PUBLIC: {
      API: {
        GET: {
          REQUEST: undefined,
          SUCCESS: apiActionPayloadCreator((config) => ({ config })),
          FAILED: apiActionPayloadCreator((error) => ({ error }))
        }
      },
      GET: undefined
    }
  }
});

export const apiActions = {
  config: {
    public: {
      get: () => commonApiActions.get(API_ENDPOINT, actions.config.public.api.get)
    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/configuration/actions.js